// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { BunzlActionUnion } from "@store/Framework/Store/Bunzl/BunzlReducer";
import { Draft } from "immer";

export interface BunzlExtraAccountSettingsState {
    firstName?: string;
    lastName?: string;
    languageId?: string;
}

const initialState: BunzlExtraAccountSettingsState = {};

const actions = {
    "Pages/AccountSettings/SetFirstName": (
        draft: Draft<BunzlExtraAccountSettingsState>,
        action: {
            firstName: string;
        },
    ) => {
        draft.firstName = action.firstName;
    },
    "Pages/AccountSettings/SetLastName": (
        draft: Draft<BunzlExtraAccountSettingsState>,
        action: {
            lastName: string;
        },
    ) => {
        draft.lastName = action.lastName;
    },
    "Pages/AccountSettings/SetLanguageId": (
        draft: Draft<BunzlExtraAccountSettingsState>,
        action: {
            languageId: string;
        },
    ) => {
        draft.languageId = action.languageId;
    },
    "Pages/AccountSettings/ResetBunzlAccountSettingsState": (draft: Draft<BunzlExtraAccountSettingsState>) => {
        draft.firstName = undefined;
        draft.lastName = undefined;
        draft.languageId = undefined;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type BunzlExtraAccountSettingsActions = BunzlActionUnion<typeof actions>;
export default reducer;
